import ko from "knockout";

export class LogEntry {
  constructor(date, message, logLevel) {
    // Short time for display and full timestamp on hover
    const shortTime = date.toTimeString().substring(0, 8);
    const fullTime = date.toLocaleString();
    this.time = ko.observable(shortTime);
    this.fullTime = ko.observable(fullTime);
    this.message = ko.observable(message);
    this.logLevel = ko.observable(logLevel);
  }
}
